import { ApolloClient, gql, InMemoryCache } from '@apollo/client';
import { BASE_URL } from './config';

export const client = new ApolloClient({
  uri: BASE_URL + '/graphql',
  cache: new InMemoryCache(),
  ssrMode: false,
});

export const GET_CARDS = gql`
  query {
    cards {
      data {
        attributes {
          Title
          About_the_performance
          Slug
          Bg_image {
            data {
              attributes {
                url
                formats
              }
            }
          }
          Buy_ticket
        }
      }
    }
  }
`;

export const GET_EVENT = gql`
  query get_card($slug: String) {
    cards(filters: { Slug: { eq: $slug } }) {
      data {
        attributes {
          Slug
          Title
          About_the_performance
          Museum_link
          Museum_logo {
            data {
              attributes {
                url
              }
            }
          }
          video {
            data {
              attributes {
                url
              }
            }
          }
          Slider {
            data {
              attributes {
                name
                url
                formats
              }
            }
          }
          More_Fields {
            Name
            Text
            Drop_Down
          }
          Buy_ticket
        }
      }
    }
  }
`;
